import styled from 'styled-components';
import { alignItems, flexbox, flexDirection, justifyContent } from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';

const FiltersBtnWrapper = styled.div((props) => {
  const { typography, palette } = ThemeHelper.getTheme(props);
  return `
    ${flexbox()}
    position: relative;

    .filters-btn {
      white-space: nowrap;
      height: ${props.height}px;

      span.isvg {
        color: ${typography.colour};

        path {
          stroke: ${palette.primary.text};
        }
      }
    }

    & > div {
      &:last-child {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  `;
});

const FiltersBtnText = styled.span((props) => {
  const { palette } = ThemeHelper.getTheme(props);
  return `
    ${flexbox()}

    span.isvg {
      margin-left: 10px;
      ${flexbox()}
      ${alignItems('center')}

      svg {
        width: 15px;
        height: 15px;
      }
      path {
        fill: ${palette.primary.text};
      }
    }
  `;
});

const ContextModalContent = styled.div`
  padding: 15px;
  height: 125px;
`;

const FilterListWrapper = styled.div`
  ${flexbox()}
  margin-bottom: 15px;
`;

const FilterList = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);
  const fullWidth = `
    width: auto;
    min-width: 100%;
  `;
  return `
    font-size: 14px;
    margin-right: 20px;

    .publications {
      ${flexDirection('row')}
      ${justifyContent('space-between')};

      width: 200px;
    }

    .grades {
      width: 100px;

      & > div {
        & > div {
          &:last-child {
            min-width: 100%;
          }
        }
      }
    }

    .courses {
      ${flexDirection('row')}
      ${justifyContent('space-between')};

      width: 200px;

      & > div {
        & > div:last-child {
          ${fullWidth}
          border: 1px solid ${colours.grey[400]};

          & > ul {
            border: none;

            & > li button {
              ${fullWidth}
              /* extra padding is applied to firefox and safari as scrollbar appears on top of content */
              @supports (-moz-appearance:none) {
                padding-right: 20px; /* firefox only */
              }
              @supports (-webkit-hyphens:none) {
                padding-right: 20px; /* safari only */
              }
            }
          }
        }
      }
    }
  `;
});

export { FilterListWrapper, FilterList, FiltersBtnWrapper, ContextModalContent, FiltersBtnText };
